'use strict';
import React from 'react';
import flux from 'utils/flux';
import {Link} from 'react-router';

var MediaListingEmpty = React.createClass({
    displayName: 'MediaListingEmpty',
    mixins: [],
    propTypes: {},
    contextTypes: {
        router: React.PropTypes.func.isRequired
    },
    clearFilters(e) {
        e.preventDefault();
        flux.getActions('media').clearQuery();
        this.context.router.transitionTo('landing-page');
    },
    render() {
        return (
            <div className="media__empty">
                <h4>{flux.t('no_search_results')}</h4>
                <Link className="btn btn-primary" to="landing-page" onClick={this.clearFilters} >{flux.t('clear_filters')}</Link>
            </div>
        );
    }
});

module.exports = MediaListingEmpty;



// WEBPACK FOOTER //
// ./app/pages/media/mediaListingEmpty.jsx